import { h } from "preact";

import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
	},
	menuButton: {
		marginRight: theme.spacing(2),
	},
	title: {
		flexGrow: 1,
	},
}));

export default function Picto8() {
	const classes = useStyles();

	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 53.18 47.18" width="47px">
			<g id="Calque_2" data-name="Calque 2">
				<g id="design">
					<path d="M12.85,14.36A14.36,14.36,0,1,0,27.21,0h0A14.37,14.37,0,0,0,12.85,14.36ZM27.21,2A12.38,12.38,0,1,1,14.83,14.36h0A12.4,12.4,0,0,1,27.21,2Z" />
					<path d="M46.45,31.16l-7.76,3.66a6.3,6.3,0,0,0-5.38-3.32l-7.16-.2a7.55,7.55,0,0,1-3.26-.84l-.73-.38a12.83,12.83,0,0,0-11.9,0l.05-1.65a1,1,0,0,0-1-1h0l-7.85-.22a1,1,0,0,0-1,1h0L0,45.4a1,1,0,0,0,1,1H1l7.85.22h0a1,1,0,0,0,1-1l0-.82,2-1.09a3.51,3.51,0,0,1,2.62-.29l12.18,3.42.06,0A13.34,13.34,0,0,0,35,46l.12-.07L52.73,34.49a1,1,0,0,0,.32-1.32A5,5,0,0,0,46.45,31.16ZM2,44.47l.42-15.25,5.87.16L7.88,44.63Zm32-.26a11.23,11.23,0,0,1-6.86.77L15,41.57A5.46,5.46,0,0,0,11,42l-1,.56.28-10.14a10.87,10.87,0,0,1,11.05-.59l.73.38a9.5,9.5,0,0,0,4.11,1.06l7.16.2a4.35,4.35,0,0,1,4.13,3.46l-10.67-.3a1,1,0,0,0-1,1,1,1,0,0,0,1,1L38.43,39h0a1,1,0,0,0,1-1,6.09,6.09,0,0,0-.1-1.28l8-3.76h0a3,3,0,0,1,3.42.48Z" />
					<path d="M31.24,14.85a3.53,3.53,0,1,0,3.53,3.53A3.53,3.53,0,0,0,31.24,14.85Zm0,5a1.51,1.51,0,1,1,1.52-1.51,1.51,1.51,0,0,1-1.52,1.51h0Z" />
					<path d="M23.17,13.86a3.53,3.53,0,1,0-3.53-3.53A3.53,3.53,0,0,0,23.17,13.86Zm0-5a1.52,1.52,0,1,1-1.51,1.51,1.52,1.52,0,0,1,1.51-1.51h0Z" />
					<path d="M20.42,21a1,1,0,0,0,1.42,0l12-12a1,1,0,0,0-1.36-1.5l-.07.08-12,12a1,1,0,0,0,0,1.41S20.4,21,20.42,21Z" />
				</g>
			</g>
		</svg>
	);
}
